import FormField from '@/zenky/forms/fields/FormField';
import Component from '@/components/forms/fields/products/ProductDimensionsField.vue';

export default class ProductDimensionsField extends FormField {
  getComponentName(): any {
    return Component;
  }
}
